export default "__VITE_ASSET__CsVZADtN__"